"use strict";

const { DateTime, Duration } = require("luxon");

const VALID_TIME_UNITS = [
  null,
  "year",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];

const VALID_COMPARISON_RANGES = [
  null,
  "previousYear",
  "previousQuarter",
  "previousMonth",
  "previousWeek",
  "previousDay",
  "previous"
];

/**
 * Validates input props
 */
const validateProps = ({
  startDate,
  endDate,
  singleDate,
  dateDuration,
  mode,
  offsetDates,
  snapDates,
  comparisonRange,
  includeTime,
  inclusiveEndDate
}) => {
  const startDateObj = DateTime.fromISO(startDate);
  const endDateObj = DateTime.fromISO(endDate);
  const singleDateObj = DateTime.fromISO(singleDate);
  const dateDurationObj = Duration.fromISO(dateDuration);

  const errors = [
    {
      validate: () =>
        [
          mode === "fixed" && startDateObj.isValid && endDateObj.isValid,
          mode === "since" && startDateObj.isValid,
          mode === "single" && singleDateObj.isValid,
          mode === "rolling" && dateDurationObj.isValid
        ].some((condition) => condition),
      message: "Requires valid input."
    },
    {
      validate: () => {
        if (startDateObj.isValid && endDateObj.isValid) {
          return startDateObj < endDateObj;
        }

        return true;
      },
      message: "Requires the startDate to be before the endDate."
    },
    {
      validate: () => typeof offsetDates === "boolean",
      message: "Requires offsetDates to be a boolean."
    },
    {
      validate: () => VALID_TIME_UNITS.includes(snapDates),
      message: "Requires a valid snapDates time-unit."
    },
    {
      validate: () => VALID_COMPARISON_RANGES.includes(comparisonRange),
      message: "Requires a valid comparisonRange."
    },
    {
      validate: () => typeof includeTime === "boolean",
      message: "Requires includeTime to be a boolean."
    },
    {
      validate: () => typeof inclusiveEndDate === "boolean",
      message: "Requires inclusiveEndDate to be a boolean."
    }
  ]
    .filter((test) => !test.validate())
    .map((test) => test.message);

  return errors;
};

module.exports = validateProps;
